import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import portalApi from "@/lib/portalApi";
import { Pill, INVOICE_STATUS, fmtDate, fmtMoney } from "@/components/portal/portalUi";
import { Empty } from "@/components/portal/QuotesTab";

export function InvoicesTab() {
  const [items, setItems] = useState(null);
  useEffect(() => { portalApi.get("/portal/invoices").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  if (!items) return <div className="py-16 text-center text-slate-400">Chargement…</div>;
  if (!items.length) return <Empty text="Aucune facture disponible." />;
  const due = items.filter((i) => ["emise", "en_retard"].includes(i.status));
  const byCur = due.reduce((acc, i) => ({ ...acc, [i.currency]: (acc[i.currency] || 0) + i.amount }), {});
  return (
    <div className="space-y-5">
      {Object.keys(byCur).length > 0 && (
        <div className="flex flex-wrap gap-4" data-testid="portal-invoices-due">
          {Object.entries(byCur).map(([cur, total]) => (
            <div key={cur} className="px-5 py-4 rounded-2xl bg-[#0F2A6B] text-white">
              <div className="text-xs uppercase tracking-wider text-slate-300">Reste à régler</div>
              <div className="mt-1 text-2xl font-bold font-head">{fmtMoney(total, cur)}</div>
            </div>
          ))}
        </div>
      )}
      <div className="rounded-2xl bg-white border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm" data-testid="portal-invoices-table">
          <thead><tr className="text-left text-xs uppercase text-slate-400 border-b border-slate-100"><th className="px-5 py-3">N°</th><th className="px-5 py-3">Objet</th><th className="px-5 py-3">Émise le</th><th className="px-5 py-3">Échéance</th><th className="px-5 py-3 text-right">Montant</th><th className="px-5 py-3">Statut</th><th className="px-5 py-3" /></tr></thead>
          <tbody>{items.map((i) => (
            <tr key={i.id} className="border-b border-slate-100 last:border-0 hover:bg-slate-50/60">
              <td className="px-5 py-3.5 font-mono text-xs text-[#0F2A6B] font-semibold">{i.number}</td>
              <td className="px-5 py-3.5 text-slate-700">{i.title || "—"}</td>
              <td className="px-5 py-3.5 text-slate-500">{fmtDate(i.issue_date)}</td>
              <td className="px-5 py-3.5 text-slate-500">{fmtDate(i.due_date)}</td>
              <td className="px-5 py-3.5 text-right font-semibold text-slate-900 whitespace-nowrap">{fmtMoney(i.amount, i.currency)}</td>
              <td className="px-5 py-3.5"><Pill map={INVOICE_STATUS} value={i.status} /></td>
              <td className="px-5 py-3.5 text-right">{i.attachment?.url && <a href={i.attachment.url} target="_blank" rel="noopener noreferrer" data-testid={`portal-invoice-download-${i.id}`} className="inline-flex items-center gap-1 text-xs font-semibold text-[#0F2A6B] hover:text-[#4CB944]"><Download className="w-3.5 h-3.5" /> PDF</a>}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
